import { useEffect, useState } from "react";
import { useAuth } from "../Components/context/Auth";

const useGetCustomerInfo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const { authTokens } = useAuth();

  const getCustomerInfo = async (customerId) => {
    if (!customerId) {
      setIsLoading(true);
      return;
    }
    try {
      setIsLoading(true);
      const message = JSON.parse(localStorage.getItem("user_MessageObj"));
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/CC_API/GetPageData?pageEnum=${676}&optionEnum1=${customerId}&accessKey=${message}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authTokens}`,
          },
        }
      ).then((response) => response.json());
      setData(response);
    } catch (error) {
      console.error('Error while fetching customer info', error);
    } finally {
      setIsLoading(false);
    }
  };

  return { data, isLoading, getCustomerInfo };
}

export default useGetCustomerInfo;
